import { useMemo } from "react";
import { PRODUCT_STATUS } from "../helpers/constants";
import { useProductStatuses } from "../services/productsService";

export const useDefaultProductStatus = () => {
    const { data: productStatusesData, ...queryState } = useProductStatuses();

    const defaultStatus = useMemo(() => {
        const statuses = productStatusesData?.results || [];
        return statuses.find((status) => status.status_name_eng === PRODUCT_STATUS.DEFAULT) || null;
    }, [productStatusesData?.results]);

    return {
        defaultStatus,
        isLoading: queryState.isLoading,
        error: queryState.error,
        isError: queryState.isError,
    };
};
